module.exports = __webpack_public_path__ + "static/media/pantry.1b02796f.jpg";